// index.less 必须放置在 import 的 第一个
import './index.less';
import '@src/global/animations.css';
import React from 'react';
import Root from '@src/components/root';
import RouteEnhance from '@src/components/route/route-enhance';
import routeConfigs from '@src/pages/app-router/route-configs';
import RouteSwitchEnhance from '@src/components/route/route-switch-enhance';
import { HashRouter as Router } from 'react-router-dom';
import getDefaultShareParams from '../../constants/share';
import qqwxShare from '../../components/hoc/qqwx-share';
import { isMQQ, isWeiXin } from 'detect-mobile-device';

@qqwxShare(getDefaultShareParams())
export default class AppRouter extends React.PureComponent {
  /**
   * 解决移动端 qq浏览器和微信 曲面屏手机 计算font-size有误，导致页面可以滑动
   */
  componentDidMount() {
    // ------- ① 初始化 rem -------
    this.initRemAdapter();
    if (isMQQ() || isWeiXin()) {
      document.documentElement.style.fontSize = `${Math.min(window.innerWidth / 10, 50)}px`;
    }
  }

  // --------------- auto-rem 宽度变化适配 -----------------
  initRemAdapter() {
    let lastAppliedWidth = window.innerWidth;
    let resizeTimer = null;
    let pollTimer = null;

    // 设置 REM
    const applyRem = w => {
      document.documentElement.style.fontSize = Math.min(w / 10, 50) + 'px';
      lastAppliedWidth = w;
    };

    // 稳定性轮询：持续检测直到宽度稳定
    const pollUntilStable = (prevWidth, stableCount = 0) => {
      clearTimeout(pollTimer);
      pollTimer = setTimeout(() => {
        const currentWidth = window.innerWidth;

        if (currentWidth === prevWidth) {
          // 连续2次相同，认为稳定
          if (stableCount >= 1) {
            if (currentWidth !== lastAppliedWidth) {
              applyRem(currentWidth);
            }
            return;
          }
          // 继续检测
          pollUntilStable(currentWidth, stableCount + 1);
        } else {
          // 宽度还在变化，重置计数
          pollUntilStable(currentWidth, 0);
        }
      }, 100);
    };

    // 主 resize 处理函数
    const onResize = () => {
      clearTimeout(resizeTimer);
      clearTimeout(pollTimer);

      // 防抖等待折叠动画（大部分设备 100-400ms）
      resizeTimer = setTimeout(() => {
        pollUntilStable(window.innerWidth, 0);
      }, 350);
    };

    // 页面可见性变化时强制更新（兜底机制）
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const currentWidth = window.innerWidth;
        if (currentWidth !== lastAppliedWidth) {
          applyRem(currentWidth);
        }
      }
    };

    window.addEventListener('resize', onResize);
    document.addEventListener('visibilitychange', onVisibilityChange);

    // 初始执行
    applyRem(window.innerWidth);

    // unmount 时清除监听
    this._removeResize = () => {
      window.removeEventListener('resize', onResize);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      clearTimeout(resizeTimer);
      clearTimeout(pollTimer);
    };
  }

  componentWillUnmount() {
    if (this._removeResize) this._removeResize();
  }

  renderRouteEnhanceElement() {
    return Object.keys(routeConfigs)
      .sort((a, b) => {
        return (routeConfigs[a].order || 0) - (routeConfigs[b].order || 0);
      })
      .map(key => <RouteEnhance key={key} {...routeConfigs[key]} />);
  }

  render() {
    return (
      <Router>
        <Root>
          <RouteSwitchEnhance>{this.renderRouteEnhanceElement()}</RouteSwitchEnhance>
        </Root>
      </Router>
    );
  }
}
